import { render, staticRenderFns } from "./CategorySensitiveAttr.vue?vue&type=template&id=c6a554cc&scoped=true"
import script from "./CategorySensitiveAttr.vue?vue&type=script&lang=js"
export * from "./CategorySensitiveAttr.vue?vue&type=script&lang=js"
import style0 from "./CategorySensitiveAttr.vue?vue&type=style&index=0&id=c6a554cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a554cc",
  null
  
)

export default component.exports